<!--
 * @Author: Zj
 * @Date: 2022-01-14 10:34:50
 * @LastEditTime: 2022-01-25 09:30:39
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gdp_cloud_app\src\components\basics\case-list-card.vue
-->
<template>
  <div class="caselistCard">
    <div class="wholePart" @click="graphCase(detail)">
      <div class="upDiv">
        <div class="name">{{detail.patientName}}</div>
        <div class="index">
          <span> NO.{{detail.index+1}}</span>
        </div>
      </div>
      <div class="downDiv">
        <div class="sex">{{detail.patientGender}}</div>
        <div class="age">{{detail.patientAge}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    detail: {}
  },
  created () {
  },
  methods: {
    graphCase (caseDetail) {
      this.$emit('graphCase', caseDetail)
    }
  }
};
</script>
<style lang='scss' scoped>
.name {
  flex: 1;
  font-size: 16px;
  color: #222222;
  text-align: left;
  font-weight: 600;
}
.index {
  margin-bottom: 14px;
  background: #ebf3ff;
  border-radius: 10.5px;
  span {
    font-size: 10px;
    color: #478ff8;
    text-align: right;
    font-weight: 600;
  }
}
.sex {
  float: left;
  padding-right: 20px;
}
.wholePart {
  padding: 14px 17px;
  box-shadow: 0px 2px 4px 1px rgb(0 0 0 / 6%);
}
.downDiv {
  font-size: 14px;
  color: #999999;
  overflow: hidden;
}
.upDiv {
  display: flex;
}
</style>

